"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataRequest {
    constructor(next, initData = undefined) {
        this.haveNewData = false;
        this.connectTime = 0;
        this.lastEmitTime = 0;
        this.emit = () => next(this.cachedData);
        this._cachedData = initData;
    }
    setCacheData(data) {
        this._cachedData = data;
        this.haveNewData = true;
    }
    get cachedData() {
        return this._cachedData;
    }
    resetTime() {
        this.haveNewData = false;
        this.connectTime = Date.now();
        this.lastEmitTime = 0;
    }
    checkDisconnect() {
        if (this.haveNewData) {
            //有新数据，连接正常
            return false;
        }
        const now = Date.now();
        if (this.lastEmitTime === 0) {
            if (now - this.connectTime > 3000) {
                //发送连接请求之后3秒还没有数据，判定为没连接成功
                console.log(`no data after connect ${now - this.connectTime}`);
                return true;
            }
        }
        else {
            if (now - this.lastEmitTime > 10000) {
                //10秒没收到数据，判定为连接断开
                return true;
            }
        }
        return false;
    }
    afterReSubscribe() {
        this.haveNewData = false;
        if (this.lastEmitTime > 0) {
            this.lastEmitTime = Date.now();
        }
        else {
            this.connectTime = Date.now();
        }
    }
    resetData(data) {
        this._cachedData = data;
        this.emitData();
        this.lastEmitTime = 0;
    }
    emitData() {
        this.emit();
        this.haveNewData = false;
        this.lastEmitTime = Date.now();
    }
}
exports.default = DataRequest;
